import get from 'lodash/get';
import { take, takeEvery, put, select } from 'redux-saga/effects';
import { consts as createPost } from './createPost';
import { consts as postsCreated } from './postsCreated';
import { consts as newPostForm } from './newPostForm';
import { consts as postsList } from './postsList';
import { consts as communityPosts } from './communityPosts';
import { consts as urlPreview } from '../common/urlPreview';
import { consts as reqCommunityInfo } from './currentCommunityInfo';
import { COMMINITY_APPROVAL_STATUS_PENDING } from '../../constants';

function* createdPostWorker(action) {
  if (action.payload.approvalStatus === COMMINITY_APPROVAL_STATUS_PENDING)
    return;
  yield put({
    type: postsList.ADD_NEW_POST,
    payload: [action.payload],
  });
  yield put({
    type: newPostForm.CLEAR_FORM,
  });
  yield put({
    type: urlPreview.CLEAR,
  });
  yield put({
    type: postsCreated.UPDATE,
    payload: 1,
  });
  yield put({
    type: reqCommunityInfo.UPDATE_POSTS_COUNTER,
  });
}

export function* createdPostSaga() {
  yield takeEvery(createPost.SUCCEED, createdPostWorker);
}

function* getPostsWorker(action) {
  // Request data according to action type
  const POSTS_PER_PAGE = 20;
  const state = yield select();

  const communityId = +get(action.payload, 'communityId');

  let limit = POSTS_PER_PAGE;
  let offset = 0;
  let responseAction = postsList.LOAD_POSTS;

  // eslint-disable-next-line default-case
  switch (action.type) {
    case communityPosts.GET_NEW_POSTS: {
      const postsFromUser = state.communities.postsCreated;
      limit = get(action.payload, 'limit', 0) + postsFromUser;
      responseAction = postsList.LOAD_NEW_POSTS;
      break;
    }
    case communityPosts.GET_OLDER_POSTS: {
      offset = get(state, 'communities.postsList.length');
      responseAction = postsList.LOAD_OLDER_POSTS;
      break;
    }
  }

  // Dispatch request
  yield put({
    type: communityPosts.SEND,
    payload: { communityId, limit, offset },
  });

  // Process response
  const response = yield take(communityPosts.SUCCEED);

  yield put({
    type: responseAction,
    payload: response.payload,
  });

  if (action.type === communityPosts.GET_NEW_POSTS) {
    yield put({
      type: postsCreated.CLEAR,
    });
  }
}

export function* getPostsSaga() {
  yield takeEvery(
    [
      communityPosts.GET_POSTS,
      communityPosts.GET_NEW_POSTS,
      communityPosts.GET_OLDER_POSTS,
    ],
    getPostsWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/communities/postsListSagas.js